import { createSelector } from '@ngrx/store';
import { OfferRenewalState } from './offer-renewal.reducer';
import { getOfferRenewalState } from './offer-renewal.selectors';

export const getOfferRenewalFormData = createSelector(
  getOfferRenewalState,
  (state: OfferRenewalState) => state.formData
);
